<template>
  <div class="acc-notif-item margin-top-m">
    <div class="large margin-bottom-xs">
      {{ INBOX.creditCards.heading }}
    </div>
    <div v-if="cardNumber">
      <p class="margin-bottom-s">
        {{ INBOX.creditCards.manageCardText(cardNumber) }}
      </p>
      <div class="margin-bottom-m">
        <CitiRedirectLink
          :action="'addcard'"
          :css="['acc-notif-button', 'secondary button expanded']"
          :aria-label="INBOX.creditCards.addCardAriaLabel"
        >
          <template #citi-link-content>
            {{ INBOX.creditCards.addCardButtonLabel }}
          </template>
        </CitiRedirectLink>
      </div>
    </div>
    <div v-else>
      <p class="margin-bottom-s">
        {{ INBOX.creditCards.setDefaultCardText }}
      </p>
      <div class="margin-bottom-m">
        <NotificationsButton :page-url="INBOX.creditCards.walletUrl" :button-label="INBOX.creditCards.setAsDefaultAriaLabel">
          {{ INBOX.creditCards.setAsDefaultButtonLabel }}
        </NotificationsButton>
      </div>
    </div>
  </div>
</template>
<script setup>
import { INBOX } from 'config';
import NotificationsButton from './NotificationsButton';
import CitiRedirectLink from '../citiRedirect/CitiRedirectLink';

defineProps({
  cardNumber: {
    type: String,
    default: '',
  },
});
</script>
